/**
 * Bridge between ApiProvider (token renewal on 401) and ContextProvider (React token state).
 * Avoids circular provider dependencies while keeping a single source of truth for the token.
 */

type RenewTokenFn = () => Promise<string>;

let renewTokenFn: RenewTokenFn | null = null;

/** When true, the next authenticated API call will fake a 401 so renewal can be tested. */
let expireOnNextApiCall = false;

export function registerTokenRenewal(fn: RenewTokenFn | null): void {
    renewTokenFn = fn;
}

export async function renewAuthToken(): Promise<string> {
    if (!renewTokenFn) {
        throw new Error("Token renewal is not registered");
    }
    return renewTokenFn();
}

/** Arm the next API call to simulate token expiry (dev testing only). */
export function armDebugExpiredOnNextRequest(): void {
    expireOnNextApiCall = true;
}

/** Returns true once, then clears the flag. Used by ApiProvider before each request. */
export function consumeDebugExpiredOnNextRequest(): boolean {
    if (!expireOnNextApiCall) {
        return false;
    }
    expireOnNextApiCall = false;
    return true;
}
